<template>
    <div
        class  ="nav-user-tab-item w-100"
    >
        <c-column-header
            label = "Benutzer Stempel"
            class = "primary"
        />

        <msd-users
            v-model="user"
        />

        <div style="position: relative">
            <div
                v-if="signature"
                class="lm-border  pl-1 pr-0 pb-0"
                style="position:absolute; left: 8px; bottom: 8px; width: 100px"
            >
                <v-slider
                    v-model="distance"
                    thumb-label
                    :thumb-size="24"
                    :ripple="false"
                    @change="onAdjustSignature"
                    dense
                    hide-details
                />
             </div>
            <div class="stamp-panel lm-border mt-3 pa-3" style="height: 300px">
                <img
                    v-if = "stamp"
                    :src = "stamp"
                    alt  =""
                    style="max-width:100%; height:auto"
                />
            </div>
        </div>
    </div>
</template>

<script>

import Msd from "@/modules/msd/common/service/Msd";
import CColumnHeader from "@/modules/core/components/utils/CColumnHeader.vue";
import MsdUsers from "@/modules/msd/user/components/controls/MsdUsers.vue";
import Preferences from "@/modules/core/service/private/Preferences";

export default {
    name: "PUserStamps",
    components: {
        MsdUsers,
        CColumnHeader,
    },

    data: () => ({
        drag: false,
        showMessage: false,
        message    : null,
        user       : null,
        signature  : null,
        stamp      : null,
        distance   : 0,
    }),

    computed: {
    },

    watch: {
        user () {
            this.load ();
        }
    },

    methods: {
        load () {
            if (!this.user) {
                return;
            }

            Msd.stamp.loadUserSignature(this.user.ident, ((data) => {
                this.signature = data;
                Msd.stamp.prepareUser(this.user.ident, "INVOICE", data => {
                    this.stamp    = data;
                    Preferences.get(this.user.ident).then(data => {
                        this.distance = data.distanceSignature;
                    })
                });
            }));
        },

        onAdjustSignature () {
            Msd.stamp.adjustUserSignature(this.user.ident, this.distance, data => {
                this.stamp = data;
            }, (message) => {
                this.message = message;
                this.showMessage = true;
            });
        }
    }
}
</script>


<style scoped>

.stamp-panel {
    display: flex;
    justify-content: center;
    align-items: center;
}

</style>